import CodeBackground from '../Componets/CodeBackground'
import SectionOne from '../Componets/SectionOne'
import SectionTwo from '../Componets/SectionTwo'
import SectionThree from '../Componets/SectionThree'
import SectionFour from '../Componets/SectionFour'
import SectionFive from '../Componets/SectionFive'
import SectionSix from '../Componets/SectionSix'
import SectionSeven from '../Componets/SectionSeven'
import Footer from '../Componets/Footer'

export default function Home() {
    return (
        <>
            <CodeBackground />

            <SectionOne />

            <SectionTwo />

            <SectionThree />

            <SectionFour />

            <SectionFive />

            <SectionSix />

            <SectionSeven />

            <Footer />
        </>
    )
}